import theme from "@/theme";
import { Theme } from "@mui/material";

export const styles = {
  wrapper: {
    width: "268px !important",
    boxSizing: "border-box",
    cursor: "pointer",
    padding: "12px",
    borderRadius: "16px",
    bgcolor: theme.palette.custom.mainWhite,
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },
  topWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
  },
  headerCol: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: "100%",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  avatar: {
    width: 64,
    height: 64,
  },
  followButton: {
    bgcolor: theme.palette.custom.mainBlue,
    borderRadius: "26px",
    textTransform: "none",
    minWidth: 0,
    height: "32px",
    padding: "6px 20px",
    fontFamily: "Inter",
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: "15px",
    lineHeight: "20px",
    letterSpacing: "-0.3px",
    color: theme.palette.custom.mainWhite,
    boxShadow: "none",
    "&:hover": { bgcolor: "#1666d6", boxShadow: "none" },
  },
  infoCol: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
  },
  usernameRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    width: "100%",
  },
  username: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "15px",
    lineHeight: "24px",
    color: theme.palette.custom.blueGray900,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  metaCol: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    width: "100%",
  },
  earningsRow: {
    display: "flex",
    alignItems: "baseline",
    gap: "6px",
  },
  earningsValue: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "17px",
    lineHeight: "24px",
    color: theme.palette.custom.mainBlack,
  },
  earningsLabel: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    color: theme.palette.custom.blueGray500,
  },
  statsRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  statChip: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
  statChipText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    color: theme.palette.custom.mainBlack,
    whiteSpace: "nowrap",
  },
  bioBox: {
    width: "100%",
  },
  bio: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    color: theme.palette.custom.blueGray900,
    display: "-webkit-box",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
  },
  footer: {
    paddingTop: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    borderTop: (theme: Theme) => `1px solid ${theme.palette.custom.blueGray100}`,
  },
  statItem: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
  },
  statValue: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "20px",
    color: theme.palette.custom.blueGray900,
  },
  statLabel: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "20px",
    color: theme.palette.custom.blueGray500,
  },
} as const;
